<template>
  <v-app>
    <v-navigation-drawer 
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      app
      width="220">
      <v-list dense>
        <v-list-tile>
          <v-list-tile-content>
            <v-btn block small color="cyan darken-3" dark @click="$refs.fileInput.click()">
              Загрузить
            </v-btn>
          </v-list-tile-content>
        </v-list-tile>
        <v-subheader>Работа с документами</v-subheader>
        <v-list-tile :to="{name: 'pending_document_list'}">
          <v-list-tile-action>
            <v-icon>mdi-cloud</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Загруженные
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{name: 'inbox_document_list'}">
          <v-list-tile-action>
            <v-icon>mdi-inbox-arrow-down</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Входящие
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{name: 'sent_document_list'}">
          <v-list-tile-action>
            <v-icon>mdi-inbox-arrow-up</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Исходящие
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{name: 'archive_document_list'}">
          <v-list-tile-action>
            <v-icon>mdi-zip-box</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Архивные
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{name: 'all_document_list'}">
          <v-list-tile-action>
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Все документы
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-subheader>Справочники</v-subheader>
        <v-list-tile :to="{name: 'organization_list'}">
          <v-list-tile-action>
            <v-icon>mdi-account-multiple-outline</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Организации
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-subheader>Настройки</v-subheader>
        <v-list-tile :to="{name: 'certificate_list'}">
          <v-list-tile-action>
            <v-icon>mdi-key</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Сертификаты
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar 
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      color="light-blue darken-3"
      class="elevation-1"
      dark
      fixed
      app>
      <v-toolbar-title class="ml-0 pl-3">
        <v-toolbar-side-icon @click.stop="drawer=!drawer"></v-toolbar-side-icon>
        <span>[edoc].cloud</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="exit()">
        <v-icon>exit_to_app</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
      <v-btn fab bottom left fixed color="cyan darken-3" dark @click="$refs.fileInput.click()">
        <v-icon>mdi-cloud-upload</v-icon>
      </v-btn>
      <DocumentUploadProgressDialog v-model="upload_dialog.show"
                                    :files="upload_dialog.files"
                                    @close="upload_dialog.show = false"/>
      <input type="file" ref="fileInput" @change="selectFilesForUpload($event)" multiple>
    </v-content>
  </v-app>
</template>

<script>
import DocumentUploadProgressDialog from '@/components/DocumentUploadProgressDialog'

export default {
  name: 'Dashboard',
  components: {
    DocumentUploadProgressDialog,
  },
  data () {
    return {
      upload_dialog: {
        show: false,
        files: []
      },
      drawer: null
    }
  },
  methods: {
    selectFilesForUpload ($event) {
      if ($event.target.files.length > 0) {
        this.upload_dialog.files = $event.target.files
        this.upload_dialog.show = true
      }
    },
    exit () {
      localStorage.clear()
      this.$router.push({ name: 'auth' })
    }
  }
}
</script>

<style scoped>
  input[type=file] {
    position: absolute;
    left: -99999px;
  }
</style>